<template>
    <div class="site">
        <div class="menuButtons">
            <MenuButton  :icons="[require('../../assets/img/deviceList_S.png'),require('../../assets/img/deviceList_U.png'),]" title="设备列表" 
            @click="menu === 1 ? menu = -1 : menu = 1" @on="isShowDeviceList = !isShowDeviceList" @off="isShowDeviceList = !isShowDeviceList"
            :selected="menu === 1"/>

            <!-- <MenuButton  :icons="[require('../assets/img/monitorS.png'),require('../assets/img/monitor_U.png'),]" title="安防监控" 
            @click="menu === 2 ? menu = -1 : menu = 2" @on="showMonitorList(true)" @off="showMonitorList(false)"
            :selected="menu === 2"/>

            <MenuButton  :icons="[require('../assets/img/接线图1.png'),require('../assets/img/接线图2.png'),]" title="接线图" 
            @click="isShowDiagram = !isShowDiagram"  @on="Diagram()" @off="Diagram1"
            :selected="isShowDiagram"/>  -->
        </div>

        <DeviceList :areaId="areaId" v-show="isShowDeviceList"/>

        <!-- <ParkOverView /> -->
        <!-- 剩余电量  -->
        <SocState />
        <!-- 电池健康 -->
        <SohState />
        <!-- 充放电统计 -->
        <ChargeDischarge />
        <!-- 变流器概况 -->
        <Bianliuqi />
        <!-- 经济效益 -->
        <Economic />

        <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree"
            :src="url + $store.getters.getThreeUrl(areaId)">
        </iframe>

        <!-- <iframe name="THREE" id="#iframe" frameborder="0" width="100%" height="100%" ref="iframeThree"
            src="">
        </iframe> -->
    </div>
</template>

<script>
const ParkOverView = () => import('../components/ParkOverView.vue')
const SocState = () => import('./components/SocState.vue')
const SohState = () => import('./components/SohState.vue')
const ChargeDischarge = () => import('./components/ChargeDischarge')
const Bianliuqi = () => import('./components/Bianliuqi')
const Economic = () => import('./components/Economic')
const MenuButton = () => import("../../components/menuButton/menuButton.vue")
const DeviceList = () => import('./components/DeviceList.vue')


import { config } from '../../config'

export default {
    data(){
        return {
            url: config.threeUrl,
            areaId:'',
            menu:0,
            isShowDeviceList:false
        }
    },
    components:{
        ParkOverView,
        SocState,
        SohState,
        ChargeDischarge,
        Bianliuqi,
        Economic,
        MenuButton,
        DeviceList
    },
    created(){
        this.areaId = this.$route.params.id
        console.log(this.areaId);
    },
    mounted(){
        this.iframeWin = this.$refs.iframeThree.contentWindow;
        this.$store.commit('set_siteId',this.areaId)
        this.$store.commit('set_page',0)
        // setTimeout(()=>{
        //     this.menu = 1
        // },100)
    }
}
</script>

<style lang="less" scoped>
    .site{
        width: 100%;
        height: 100%;
        .menuButtons{
            width: 10vw;
            height: 7vh;
            position: fixed;
            top: 6.8vh;
            left: 22.5vw;
            display: flex;
            flex-direction: row;
        }
    }
</style>